var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("input", { attrs: { type: "file" }, on: { change: _vm.onChange } }),
    _vm._v(" "),
    _c(
      "button",
      {
        class: _vm.btnClass,
        attrs: { type: "button" },
        on: { click: _vm.onBeforeUpload }
      },
      [_vm._v(_vm._s(_vm.$t(_vm.btnLabel)))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62e74bda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e74bda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/excel/ExcelUpload.vue
// module id = null
// module chunks = 